import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Header } from '@/components/Header';

const TestMode = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedMode, setSelectedMode] = useState<'study' | 'exam' | null>(null);

  useEffect(() => {
    // Redirect to home if not authenticated
    if (!user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleModeSelect = (mode: 'study' | 'exam') => {
    console.log('Mode selected:', mode);
    setSelectedMode(mode);
    navigate('/subjects', { 
      state: { 
        mode: mode,
        timestamp: Date.now()
      } 
    });
  };

  // Don't render anything while checking authentication
  if (!user) return null;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-col items-center px-4 pt-[40px] sm:pt-[60px]">
        <h1 className="text-[48px] font-bold mb-12">Select Test Mode</h1>

        <div className="flex gap-6 max-w-3xl">
          <div 
            onClick={() => handleModeSelect('study')}
            className={`flex-1 p-6 rounded-xl border cursor-pointer transition-colors ${
              selectedMode === 'study'
                ? 'border-purple-500 bg-purple-100'
                : 'border-gray-200 bg-gray-50 hover:bg-gray-100'
            }`}
          >
            <h2 className={`text-xl font-semibold mb-2 ${
              selectedMode === 'study' ? 'text-purple-600' : 'text-gray-600'
            }`}>Study Mode</h2>
            <p className="text-gray-600">Practice at your own pace. Get immediate feedback after each question.</p>
            <ul className="mt-4 text-sm text-gray-500 list-disc list-inside">
              <li>See correct answers immediately</li>
              <li>Review answers as you go</li>
              <li>Perfect for learning and practice</li>
            </ul>
          </div>

          <div 
            onClick={() => handleModeSelect('exam')}
            className={`flex-1 p-6 rounded-xl border cursor-pointer transition-colors ${
              selectedMode === 'exam'
                ? 'border-purple-500 bg-purple-100'
                : 'border-gray-200 bg-gray-50 hover:bg-gray-100'
            }`}
          >
            <h2 className={`text-xl font-semibold mb-2 ${
              selectedMode === 'exam' ? 'text-purple-600' : 'text-gray-600'
            }`}>Exam Mode</h2>
            <p className="text-gray-600">Simulate real exam conditions. See your score after completing all questions.</p>
            <ul className="mt-4 text-sm text-gray-500 list-disc list-inside">
              <li>Timed assessment</li>
              <li>No immediate feedback</li>
              <li>Results shown at the end</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestMode; 